import React from 'react'
import { Button, Box, Typography } from '@mui/material'
import { useFieldArray, useWatch } from 'react-hook-form'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { MAX_NUMBER_OF_SECURITY_TEMPERATURE } from '../../constants'
import { AddIcon } from 'src/Libs/flow/icons'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { BoostConfigSchedule, createDefaultBoostConfig } from './BoostConfigSchedule'
import { Stack } from '@mui/system'
import { getScheduleConflicts } from '../../storage/utils/blocking-times-utils'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

export const BoostConfig: React.FC = () => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  const { control } = useInstallationForm()
  const boostConfig = useWatch({ control, name: 'ioInterfaces.mypv.boostConfig' })
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'ioInterfaces.mypv.boostConfig',
  })

  const validatedSchedules = getScheduleConflicts(boostConfig)

  const reachedMaxNumberOfRules = fields.length >= MAX_NUMBER_OF_SECURITY_TEMPERATURE

  return (
    <Stack spacing={2}>
      {fields.map((item, index) => (
        <BoostConfigSchedule
          key={item.id}
          index={index}
          remove={() => remove(index)}
          errorWeekdays={validatedSchedules[index]?.errorWeekdays}
          conflictingScheduleIndex={validatedSchedules[index]?.conflictingScheduleIndex}
        />
      ))}
      {canEdit && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {reachedMaxNumberOfRules && (
            <Typography variant="caption" sx={{ ml: 3 }}>
              {t('user-settings.boiler-page.calendar-editor.max-rules-error', '', {
                value: MAX_NUMBER_OF_SECURITY_TEMPERATURE.toString(),
              })}
            </Typography>
          )}
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
            startIcon={<AddIcon />}
            onClick={() => append(createDefaultBoostConfig())}
            disabled={reachedMaxNumberOfRules}
          >
            {t('common.add')}
          </Button>
        </Box>
      )}
    </Stack>
  )
}
